import { render } from "./App.vue?vue&type=template&id=3757984d"
const script = {}

import exportComponent from "/Users/jieonkim/Documents/workspace/strokcare-app-web-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__